import {
  GET_WAREHOUSE_CHECK_CAMPAIGN_NAMES,
  SET_WAREHOUSE_CHECK_CAMPAIGN_NAMES,
  CHECK_NAMES_WH_LOADER,
  GET_WAREHOUSE_CABINET_LIMITS,
  SET_WAREHOUSE_CABINET_LIMITS,
  WAREHOUSE_CABINET_LIMITS_LOADER,
  GET_WAREHOUSE_CABINET_LIMITS_TOTAL,
  SET_WAREHOUSE_CABINET_LIMITS_TOTAL
} from "./actionTypes";

export const getCabinetLimits = data => ({
  type: GET_WAREHOUSE_CABINET_LIMITS,
  payload: data,
});


export const setCabinetLimits = data => ({
  type: SET_WAREHOUSE_CABINET_LIMITS,
  payload: data,
});

export const cabinetLimitsLoader = () => ({
  type: WAREHOUSE_CABINET_LIMITS_LOADER,
})

export const getCabinetLimitsTotal = data => ({
  type: GET_WAREHOUSE_CABINET_LIMITS_TOTAL,
  payload: data,
})

export const setCabinetLimitsTotal = data => ({
  type: SET_WAREHOUSE_CABINET_LIMITS_TOTAL,
  payload: data,
})

export const getWHCheckCampaignNames = (payload) => ({
  type: GET_WAREHOUSE_CHECK_CAMPAIGN_NAMES,
  payload
});

export const setWHCheckCampaignNames = data => ({
  type: SET_WAREHOUSE_CHECK_CAMPAIGN_NAMES,
  payload: data,
});

export const WarehouseNamesLoader = () => ({
  type: CHECK_NAMES_WH_LOADER,
})